import { useCallback } from 'react';
import { actions } from 'state';
import useThrottledCallback from './useThrottledCallback';

const useLendersByProductsView = ({
  dispatch,
  lendersByProductsIsLoading,
  lendersByProductsMeta,
}: {
  dispatch: Function;
  lendersByProductsIsLoading: boolean;
  lendersByProductsMeta: { hasMore: boolean; total: number };
}) => {
  const clearResults = useCallback(() => dispatch(actions.lendersByProducts.clearResults()), [dispatch]);
  const fetch = useCallback(
    (filters: Record<string, unknown>) => dispatch(actions.lendersByProducts.fetch(filters)),
    [dispatch]
  );
  const fetchMoreAction = useCallback(() => dispatch(actions.lendersByProducts.fetchMore()), [dispatch]);
  const fetchMore = useThrottledCallback(fetchMoreAction);

  return {
    clearResults,
    fetch,
    fetchMore,
    hasMore: lendersByProductsMeta.hasMore,
    isLoadingData: lendersByProductsIsLoading,
    total: lendersByProductsMeta.total,
  };
};

export default useLendersByProductsView;
